import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { totalRowRatio } from '../../../../../react-table/helpers/rowTotals';
import UserTypes from '../../../../../common/redux/actions/types/UserTypes';
import DirectionTypes from '../../../../../common/redux/actions/types/DirectionTypes';

export const getDetailsTabNavOptions = direction => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_DETAILS.id,
    mainReportId: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_SUMMARY.id,
    requestParams: {
      carrier: rowInfo.row.carrier,
      direction,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {}
);

export const getOwnPropertyConditionalProps = userType => (state, rowInfo) => {
  if (rowInfo) {
    const { row } = rowInfo;
    if (row.globalScore === null) {
      row.globalScore = '-';
    }
  }
  const className = userType !== UserTypes.IPC && rowInfo && rowInfo.original.ownCarrier ? 'bg-blue-spindle' : '';
  return { className };
};

export const isOwnOperator = userType => rowInfo =>
  userType === UserTypes.IPC ||
  (rowInfo && rowInfo.original && rowInfo.original.ownCarrier === true);

export default (data, userType) => {
  const {
    TextColumn,
    NonZeroPercentageColumn,
    NavigationWithFooterPercentageColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Carrier', 'carrier').withTotalHeader('Total').withGetProps(getOwnPropertyConditionalProps(userType)).withWidth(180),
        new NonZeroPercentageColumn('', 'globalScoreVolume').withShow(false),
        new NonZeroPercentageColumn('', 'globalScorePfVolume').withShow(false),
        new NavigationWithFooterPercentageColumn(new NonZeroPercentageColumn('Global score', 'globalScore')
          .withTotalHeader(totalRowRatio(['globalScorePfVolume', 'globalScoreVolume']))
          .withGetProps(getOwnPropertyConditionalProps(userType))
          // eslint-disable-next-line max-len
          .withWidth(180), getDetailsTabNavOptions(DirectionTypes.OUTBOUND), isOwnOperator(userType)),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_DETAILS.id,
        mainReportId: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_SUMMARY.id,
        requestParams: {
          isTotal: true,
          carrier: '*',
          direction: DirectionTypes.OUTBOUND,
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
